export function transformRegistryPackages(response) {
  return response?.objects.map(obj => obj.package)
}
